import { render } from "./ProjectCard.vue?vue&type=template&id=0680c562&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=0680c562&scoped=true&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0680c562"]])

export default __exports__